import Box from '@material-ui/core/Box'
import Theme from '@material-ui/core/styles/MuiThemeProvider'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/styles'
import React from 'react'

import StepIndicator from '../StepIndicator'

interface IdentificationHeaderProps {
  contentLogo: boolean
  totalSteps?: number
}

const useStyles = makeStyles((theme: Theme) => ({
  legendTitle: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 700,
    color: '#1F2937',
    margin: '16px 0px',
    textAlign: 'center',
  },
  legendSubTitle: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
    color: '#1F2937CC',
    textAlign: 'center',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  contentLogo: {
    width: '100%',
    maxHeight: 174,
    maxWidth: 261,
  },
  stepsArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 32,
    width: '100%',
    marginTop: 24,
  },
  stepText: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    color: '#111827',
  },
}))

export default function IdentificationHeader({
  contentLogo = false,
  totalSteps = 4,
}: IdentificationHeaderProps): JSX.Element {
  const classes = useStyles()
  return (
    <Box className={classes.container}>
      {contentLogo && (
        <Box className={classes.contentLogo}>
          <img
            src="/assets/images/type-scheduler.svg"
            width="100%"
            height="auto"
            alt="favorite"
          />
        </Box>
      )}
      <Typography className={classes.legendTitle}>
        Escolha para quem é o agendamento
      </Typography>
      <Typography className={classes.legendSubTitle}>
        Escolha abaixo o perfil e quem fará o agendamento.
      </Typography>
      <Box className={classes.stepsArea}>
        <Typography className={classes.stepText}>
          Passo 1 de {totalSteps}
        </Typography>
        <StepIndicator currentStep={1} totalSteps={totalSteps} />
      </Box>
    </Box>
  )
}
